import React from 'react'

const createStockRecevingDetail = () => {
   return (()=>{
    return (
    <>
    Detail
    </>
    )
   })
  
}

export default createStockRecevingDetail